import { useMutation } from "react-query";

import { fetchClient } from "@/lib/fetchClient";
import type { MutationConfig } from "@/lib/react-query";
import { queryClient } from "@/lib/react-query";
import type { Folder } from "@/types/resources";

type CreateFolderDTO = {
  data: {
    name: string;
  };
};

async function createFolder({ data }: CreateFolderDTO) {
  await fetchClient.POST("/folders", {
    body: data,
  });
}

type UseCreateFolderOptions = {
  config?: MutationConfig<typeof createFolder>;
};

export const useCreateFolder = ({ config }: UseCreateFolderOptions = {}) => {
  return useMutation({
    onMutate: async (_) => {
      await queryClient.cancelQueries("folders");

      const previousFolders = queryClient.getQueryData<Folder[]>("folders");

      return { previousFolders };
    },
    onError: (_, __, context: unknown) => {
      if (
        typeof context === "object" &&
        context !== null &&
        "previousFolders" in context
      ) {
        queryClient.setQueryData("folders", context.previousFolders);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries("folders");
    },
    ...config,
    mutationFn: createFolder,
  });
};
